define.alias("shared/components/shared/social/basic-display-deprecation/modal", "calendar/components/shared/social/basic-display-deprecation/modal");